import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import axios, { AxiosError } from "axios";
import { useQuery, useMutation } from "react-query";
import { API_URL } from "../consts";
import { Loading } from "../ui/Loading";
import { EuroFormatter } from "../utils/EuroFormatter";
import { PrenotazioneData } from "./PrenotazioneData";
import { useSnackbar } from "notistack";
import { queryClient } from "../App";
import { memo } from "react";

interface Data2 {
  gettoni: number;
  costoLuci: number;
  costoRiscaldamento: number;
  luciForfait: number;
  costoRiscaldamentoForfait: number;
  gettoniL: number;
  gettoniR: number;
}

interface AcquistaGettoniDto {
  idPrenotazione: number;
  tipo: string;
  costo: number;
  quantita: number;
}

export const CoinManager = memo(function CoinManager(props: {
  data: PrenotazioneData;
  type: string;
  handleClose: () => void;
}) {
  const { data, type, handleClose } = props;
  const { enqueueSnackbar } = useSnackbar();

  const { isLoading, data: gettoni } = useQuery<unknown, AxiosError, Data2>(
    ["prenotazioni/gettoni", data.id],
    () => axios.get(API_URL + "prenotazioni/gettoni/" + data.id).then((res) => res.data),
    { refetchInterval: 2 * 60 * 1000 },
  );

  const { mutate } = useMutation(
    (data: AcquistaGettoniDto) => axios.post(API_URL + "prenotazioni/acquistaGettoni", data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries();
        enqueueSnackbar("Acquisto effettuato", { variant: "success" });
        handleClose();
      },
      onError: (error: AxiosError) => {
        queryClient.invalidateQueries();
        enqueueSnackbar(error?.response?.data?.message ?? "Si è verificato un errore!", {
          variant: "error",
        });
      },
    },
  );

  let euro = 0;
  if (data && gettoni) {
    if (type === "L") {
      if (gettoni.luciForfait) euro = gettoni.costoLuci;
      else euro = gettoni.costoLuci * gettoni.gettoniL;
    } else {
      if (gettoni.costoRiscaldamentoForfait) euro = gettoni.costoRiscaldamento;
      else euro = gettoni.costoRiscaldamento * gettoni.gettoniR;
    }
  }

  const compra = () => {
    if (gettoni)
      mutate({
        idPrenotazione: data.id,
        tipo: type,
        costo: euro,
        quantita: gettoni.gettoni,
      });
  };

  if (isLoading || !gettoni) return <Loading />;

  return (
    <>
      <DialogTitle sx={{ textAlign: "center", paddingBottom: 0 }}>Acquisto Gettoni</DialogTitle>
      <DialogContent sx={{ textAlign: "center" }}>
        <DialogContentText>
          {type === "L" ? "Luci" : "Riscaldamento"}( €{" "}
          {EuroFormatter.format(type === "L" ? gettoni.costoLuci : gettoni.costoRiscaldamento)} cad.
          )
        </DialogContentText>
        <Typography variant="h1" fontWeight="500" sx={{ mt: 2 }}>
          <Box component="span" sx={{ fontSize: "175%" }}>
            {EuroFormatter.format(euro)}
          </Box>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => compra()}>Conferma Acquisto</Button>
        <Button onClick={() => handleClose()}>Annulla</Button>
      </DialogActions>
    </>
  );
});
